import moment from "moment";

export type Args = {
  startDateTime: string;
  endDateTime: string;
  eventTitle: string;
  eventDescription?: string;
  eventUrl?: string;
};

export function createGoogleCalendarUrl({
  startDateTime,
  endDateTime,
  eventTitle,
  eventDescription,
  eventUrl,
}: Args) {
  // Format dates for Google Calendar (YYYYMMDDTHHMMSSZ format)
  const startTime = moment.utc(startDateTime).format("YYYYMMDDTHHmmss") + "Z";
  const endTime = moment.utc(endDateTime).format("YYYYMMDDTHHmmss") + "Z";

  // Create the Google Calendar URL
  const baseUrl = "https://calendar.google.com/calendar/render";

  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: eventTitle,
    dates: `${startTime}/${endTime}`,
    location: eventUrl || "",
    details: eventDescription || "",
  });

  return `${baseUrl}?${params.toString()}`;
}

export default createGoogleCalendarUrl;
